import { 
    ADMIN_FETCH_NOTIFICATIONS,
    ADMIN_FETCH_NOTIFICATIONS_SUCCESS,
    ADMIN_FETCH_NOTIFICATIONS_FAILED,
  } from "../actions/types";
  
  export const INITIAL_STATE = {
    notifications:null,
    loading: false,
    error:{
      flag:false,
      msg: null
    }
  }
  
  export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case ADMIN_FETCH_NOTIFICATIONS:
        return {
          ...state,
          loading:true
        };
      case ADMIN_FETCH_NOTIFICATIONS_SUCCESS:
        return {
          ...state,
          notifications:action.payload,
          loading:false
        };
      case ADMIN_FETCH_NOTIFICATIONS_FAILED:
        return {
          ...state,
          notifications:null,
          loading:false,
          error:{
            flag:true,
            msg:action.payload
          }
        };
      default:
        return state;
    }
  };
